<template>
  <v-app id="app">
    <!-- 배너 -->
    <PopupBanner/>
    <!-- 유틸 -->
    <Alert/>
    <!-- 회원관련 컴포넌트 -->
    <Auth/>
    <!-- 방찾아주세요 컴포넌트 -->
    <FindRoom/>
    <!-- 찜한매물 -->
    <FavoriteView/>
    <!-- 캘린더 -->
    <IFrameView/>
    <!-- 방내놓기 -->
    <ItemReceipt/>
    <!-- 동영상 -->
    <RequestRoom/>
    <!-- 방의뢰 -->
    <VideoView/>
    <!-- 모바일 고정바 -->
    <MobileBar/>
    <!-- 최신브라우저 경고> -->
    <BrowserAlert/>
    <!-- 라우터 -->
    <router-view/>
  </v-app>
</template>

<script>
import MobileBar from './components/layout/MobileBar'
import BrowserAlert from './components/layout/BrowserAlert'
import Auth from './components/modal/Auth'
import FindRoom from './components/modal/FindRoom'
import FavoriteView from './components/modal/FavoriteView'
import ItemReceipt from './components/modal/ItemReceipt'
import IFrameView from './components/modal/IFrameView'
import RequestRoom from '@/components/modal/RequestRoom'
import VideoView from '@/components/modal/VideoView'

import PopupBanner from './components/modal/popupBanner'

import Alert from './components/utile/Alert'

import { mapActions } from 'vuex'

export default {
  name: 'App',
  components: { IFrameView, MobileBar, Auth, Alert, FindRoom, FavoriteView, ItemReceipt, RequestRoom, VideoView, PopupBanner, BrowserAlert },
  mounted () {
    // 콘피그 로드
    this.loadConfigData()
  },
  methods: {
    ...mapActions({
      loadConfigData: 'config/loadConfigData'
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue